"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVue3 = void 0;
const isVue3 = (app) => {
    return app.version.startsWith('3');
};
exports.isVue3 = isVue3;
